export default __webpack_public_path__ + "static/media/pic8.df007df0.jpg";